import { render, staticRenderFns } from "./myApproveList.vue?vue&type=template&id=4c616ffa&scoped=true&"
import script from "./myApproveList.vue?vue&type=script&lang=js&"
export * from "./myApproveList.vue?vue&type=script&lang=js&"
import style0 from "./myApproveList.vue?vue&type=style&index=0&id=4c616ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c616ffa",
  null
  
)

export default component.exports